function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useRef, useCallback } from 'react';
import cn from 'classnames';
import { Link } from '../Link';
import { PinInput } from '../PinInput';
import { Preloader } from '../Preloader';
import { UpdateCode } from './UpdateCode/UpdateCode';
require("./SmsForm.css");
var styles = {
  "Root": "SmsForm-module-Root_6LR",
  "Header": "SmsForm-module-Header_2gE",
  "Headline": "SmsForm-module-Headline_7ca",
  "Description": "SmsForm-module-Description_1ET",
  "Footer": "SmsForm-module-Footer_2ZP",
  "Error": "SmsForm-module-Error_3I1",
  "Addons": "SmsForm-module-Addons_U-3",
  "Preloader": "SmsForm-module-Preloader_30w"
};
export const SmsForm = ({
  className,
  clearError,
  controlRef,
  errorMessage,
  innerRef,
  isLoading = false,
  onCompareCode,
  onReEntryPhone,
  onSendSmsCode,
  onUpdateSmsCode,
  phone,
  style
}) => {
  const inputRef = useRef(null);
  useEffect(() => {
    if (onSendSmsCode) {
      onSendSmsCode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (errorMessage && inputRef?.current) {
      inputRef.current.value = '';
    }
  }, [errorMessage]);
  const handleSubmit = code => {
    if (onCompareCode) {
      onCompareCode(code);
    }
  };
  const handleFocus = useCallback(() => {
    if (clearError && errorMessage) {
      clearError();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorMessage]);
  return /*#__PURE__*/React.createElement("form", {
    className: cn(styles.Root, className),
    style: style,
    ref: innerRef || controlRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Headline
  }, phone), /*#__PURE__*/React.createElement(UpdateCode, {
    input: inputRef,
    onUpdateSmsCode: onUpdateSmsCode
  })), /*#__PURE__*/React.createElement(PinInput, _extends({
    disabled: isLoading,
    length: 4
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onComplete: handleSubmit
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onFocus: handleFocus,
    controlRef: inputRef
  }, Boolean(errorMessage) && {
    state: 'error'
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.Addons
  }, errorMessage && /*#__PURE__*/React.createElement("div", {
    className: styles.Error
  }, errorMessage), isLoading && /*#__PURE__*/React.createElement(Preloader, {
    className: styles.Preloader
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.Footer
  }, /*#__PURE__*/React.createElement(Link, {
    tag: "button",
    "aria-label": "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    onClick: onReEntryPhone
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"))));
};
if (process.env.NODE_ENV !== 'production') {
  SmsForm.displayName = 'SmsForm';
}